// assets/nd-quote-detail-v8.js
// Quote 詳細頁：顯示明細＋載回購物車（v8.1, Final/Draft 同步支援）
// (migrated out of theme.liquid)
// PATCH: add properties._nd_reload="1" when restoring cart items (ONLY this change)
// PATCH2 (SAFE): normalize properties shape (object/array/json-string) before /cart/add.js
// PATCH3 (Route1): inject properties._nd_options_state from payload_json.nd_options_state_by_variant when restoring cart items
// PATCH4 (STABILITY): write Reference/Factor to BOTH cart attributes + line item properties using multi-key aliases + strict fetch ok checks

(function () {
  var path = (window.location.pathname || '').toLowerCase();
  if (path.indexOf('quotation-detail') === -1 && path.indexOf('quote') === -1) return;
  if (window.__ND_QUOTE_DETAIL_V8__) return;
  window.__ND_QUOTE_DETAIL_V8__ = true;

  var body = document.body;
  if (!body) return;

  var apiUrl = body.dataset.quotesApiUrl;
  var apiKey = body.dataset.quotesApiKey;
  if (!apiUrl || !apiKey) {
    console.warn('[QuoteDetail] missing apiUrl/apiKey');
    return;
  }

  /* ---------- 永久隱藏舊版 Quote / Shipping 卡片（.nd-quote-extra） ---------- */
  function injectLegacyHideStyle() {
    try {
      if (!document.head) return;
      if (document.getElementById('nd-hide-legacy-quote-extra')) return;
      var style = document.createElement('style');
      style.id = 'nd-hide-legacy-quote-extra';
      style.textContent = '.nd-quote-extra{display:none !important;}';
      document.head.appendChild(style);
    } catch (e) {
      console.warn('[QuoteDetail] injectLegacyHideStyle error', e);
    }
  }
  injectLegacyHideStyle();

  // 記住目前這筆 quote（Google Sheet 平面欄位）
  var lastQuote = null;

  function getQuoteId(){
    try {
      var params = new URLSearchParams(window.location.search || '');

      // ✅ support current param: quoteId
      var v =
        params.get('quoteId') ||
        params.get('quoteid') ||
        params.get('quote_id') ||
        params.get('quotation_id') ||
        params.get('id') ||
        params.get('qid') ||
        params.get('draft_id') ||
        params.get('quotation_no');

      return v ? String(v).trim() : null;
    } catch(e) {
      return null;
    }
  }

  var quoteId = getQuoteId();
  if (!quoteId) return;

  /* ---------- 佈局 ---------- */
  var main = document.querySelector('#MainContent') || document.body;
  main.innerHTML = '';

  var wrapper = document.createElement('div');
  wrapper.className = 'page-width page-width--narrow';
  main.appendChild(wrapper);

  var root = document.createElement('div');
  root.id = 'nd-quote-detail-root';
  wrapper.appendChild(root);

  var back = document.createElement('p');
  back.style.marginTop = '16px';
  back.innerHTML = '<a href="/account">\u2190 Back to Account</a>';
  wrapper.insertBefore(back, root);

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderError(msg) {
    root.innerHTML =
      '<p style="color:#b91c1c;font-size:14px;">' + escapeHtml(msg) + '</p>';
  }

  root.innerHTML =
    '<p style="font-size:14px;">Loading quote ' +
    escapeHtml(quoteId) +
    '\u2026</p>';

  var url =
    apiUrl +
    '?action=get' +
    '&apiKey=' +
    encodeURIComponent(apiKey) +
    '&id=' +
    encodeURIComponent(quoteId);

  /* ---------- JSON 安全解析：可處理 double-encode ---------- */
  function safeParseJson(maybeJson) {
    if (!maybeJson) return null;
    if (typeof maybeJson === 'object') return maybeJson;
    var txt = String(maybeJson).trim();
    if (!txt) return null;

    try {
      var v = JSON.parse(txt);
      if (typeof v === 'string') {
        try {
          var v2 = JSON.parse(v);
          return typeof v2 === 'object' && v2 ? v2 : null;
        } catch (e2) {
          return null;
        }
      }
      return typeof v === 'object' && v ? v : null;
    } catch (e) {
      console.warn('[QuoteDetail] safeParseJson first parse failed', e);
      return null;
    }
  }

  /* ---------- 從 payload 裡撈出 items ---------- */
  function pickCartItems(cartData) {
    if (!cartData || typeof cartData !== 'object') return null;

    if (Array.isArray(cartData.items)) return cartData.items;

    if (cartData.cart && Array.isArray(cartData.cart.items)) {
      return cartData.cart.items;
    }

    if (cartData.cart_snapshot && Array.isArray(cartData.cart_snapshot.items)) {
      return cartData.cart_snapshot.items;
    }

    if (cartData.payload && Array.isArray(cartData.payload.items)) {
      return cartData.payload.items;
    }

    function findItemsDeep(obj, depth) {
      if (!obj || typeof obj !== 'object' || depth > 4) return null;
      if (Array.isArray(obj.items)) return obj.items;
      for (var k in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
        var v = obj[k];
        if (v && typeof v === 'object') {
          var found = findItemsDeep(v, depth + 1);
          if (found) return found;
        }
      }
      return null;
    }
    return findItemsDeep(cartData, 0);
  }

  /* ---------- PATCH3 helper: 從 payload 裡撈出 nd_options_state_by_variant ---------- */
  function pickNdStateMap(payloadObj) {
    try {
      if (!payloadObj || typeof payloadObj !== 'object') return {};
      // most expected: payload_json.nd_options_state_by_variant
      if (payloadObj.nd_options_state_by_variant && typeof payloadObj.nd_options_state_by_variant === 'object') {
        return payloadObj.nd_options_state_by_variant;
      }
      // sometimes nested under cart (rare, but safe)
      if (payloadObj.cart && payloadObj.cart.nd_options_state_by_variant && typeof payloadObj.cart.nd_options_state_by_variant === 'object') {
        return payloadObj.cart.nd_options_state_by_variant;
      }
      // sometimes under payload/cart_snapshot wrappers
      if (payloadObj.payload && payloadObj.payload.nd_options_state_by_variant && typeof payloadObj.payload.nd_options_state_by_variant === 'object') {
        return payloadObj.payload.nd_options_state_by_variant;
      }
      if (payloadObj.cart_snapshot && payloadObj.cart_snapshot.nd_options_state_by_variant && typeof payloadObj.cart_snapshot.nd_options_state_by_variant === 'object') {
        return payloadObj.cart_snapshot.nd_options_state_by_variant;
      }
      return {};
    } catch (e) {
      return {};
    }
  }

  function toStateString(v) {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    try { return JSON.stringify(v); } catch (e) { return String(v); }
  }

  /* ---------- Apps Script 存的 payload -> {cart, meta} ---------- */
  function normalizePayload(payload, quoteFlat) {
    if (!payload || typeof payload !== 'object') payload = {};
    var rootPayload = payload;
    var cart = null;

    if (rootPayload.cart && typeof rootPayload.cart === 'object') {
      cart = rootPayload.cart;
    } else if (
      Array.isArray(rootPayload.items) ||
      rootPayload.attributes ||
      rootPayload.note !== undefined
    ) {
      cart = rootPayload;
    } else if (rootPayload.cart_snapshot && typeof rootPayload.cart_snapshot === 'object') {
      cart = rootPayload.cart_snapshot;
    } else if (rootPayload.payload && typeof rootPayload.payload === 'object') {
      cart = rootPayload.payload;
    }

    var meta = (rootPayload.meta && typeof rootPayload.meta === 'object') ? rootPayload.meta : {};

    if (quoteFlat) {
      if (quoteFlat.factor != null && meta.factor == null) meta.factor = quoteFlat.factor;
      if (quoteFlat.reference_numb && !meta.reference) meta.reference = quoteFlat.reference_numb;
      if (quoteFlat.contact_name && !meta.contact_name) meta.contact_name = quoteFlat.contact_name;
      if (quoteFlat.phone_number && !meta.phone_number) meta.phone_number = quoteFlat.phone_number;
      if (quoteFlat.company_name && !meta.company_name) meta.company_name = quoteFlat.company_name;
      if (quoteFlat.shipping_address && !meta.shipping_address) meta.shipping_address = quoteFlat.shipping_address;
      if (quoteFlat.special_instruction && !meta.instruction) meta.instruction = quoteFlat.special_instruction;
    }

    return { cart: cart, meta: meta };
  }

  /* ---------- ND localStorage 清除工具：避免舊暫存蓋掉新載入內容 ---------- */
  function clearNdLocalCache() {
    try {
      if (!window.localStorage) return;

      var explicitKeys = [
        'ND:QUOTE_DRAFT',
        'ND:QUOTE_DRAFT_NAME',
        'ND:CART_ATTRS_CACHE',
        'ND:CART_SHIPPING_CACHE',
        'ND:SERIAL2',
        'ND_LAST_FINAL_QUOTE',
        'ND_QUOTE_FINAL_INFO',
        'ND_QUOTE_SERIAL_FULL'
      ];

      explicitKeys.forEach(function (k) {
        try { localStorage.removeItem(k); } catch (e) {}
      });

      Object.keys(localStorage).forEach(function (k) {
        var key = k.toLowerCase();
        if (
          key.indexOf('nd:quote') === 0 ||
          key.indexOf('nd:cart') === 0 ||
          key.indexOf('nd:serial') === 0 ||
          key.indexOf('nd_quote') === 0 ||
          key.indexOf('nd_last') === 0
        ) {
          try { localStorage.removeItem(k); } catch (e) {}
        }
      });

      console.info('[QuoteDetail] ND localStorage cache cleared before restore');
    } catch (err) {
      console.warn('[QuoteDetail] clearNdLocalCache error', err);
    }
  }

  /* ---------- PATCH4 helpers: multi-key write for stability ---------- */
  function setAttrAliases(attrs, base, val) {
    if (!attrs || !base) return;
    if (val == null) return;
    var s = String(val).trim();
    if (!s) return;

    // Never overwrite existing non-empty values (avoid odd flicker)
    function put(k) {
      try {
        if (attrs[k] == null || String(attrs[k]).trim() === '') attrs[k] = s;
      } catch (e) {}
    }

    // base itself
    put(base);

    var b = String(base).toLowerCase();

    // factor aliases
    if (b.indexOf('factor') !== -1) {
      ['Factor', 'factor', 'ND_FACTOR', 'nd_factor'].forEach(put);
      return;
    }

    // reference aliases
    if (b.indexOf('reference') !== -1) {
      [
        'Reference Number',
        'Reference #',
        'Reference',
        'reference',
        'reference_numb',
        'Reference Number ',
        'ND_REFERENCE',
        'nd_reference'
      ].forEach(put);
      return;
    }
  }

  function setPropAliases(props, refVal, factorVal) {
    if (!props || typeof props !== 'object') return props;
    if (refVal != null && String(refVal).trim() !== '') {
      var r = String(refVal).trim();
      ['Reference Number','Reference #','Reference','reference','reference_numb','ND_REFERENCE','nd_reference'].forEach(function(k){
        try { if (props[k] == null || String(props[k]).trim() === '') props[k] = r; } catch(e){}
      });
    }
    if (factorVal != null && String(factorVal).trim() !== '') {
      var f = String(factorVal).trim();
      ['Factor','factor','ND_FACTOR','nd_factor'].forEach(function(k){
        try { if (props[k] == null || String(props[k]).trim() === '') props[k] = f; } catch(e){}
      });
    }
    return props;
  }

  function fetchJsonOrThrow(url, opts, label) {
    return fetch(url, opts).then(function(res){
      if (!res || !res.ok) {
        throw new Error((label || 'request') + ' failed: ' + (res ? res.status : 'no_res'));
      }
      return res;
    });
  }

  /* ---------- 還原到購物車（商品 + Factor / Shipping 等） ---------- */
  function restoreCart(items, payload, quoteFlat, btn) {
    if (!items || !items.length) {
      alert('No items in this quote.');
      return;
    }

    // PATCH3: read state map from payload_json
    var ndStateMap = pickNdStateMap(payload || {});
    try {
      console.log('[QuoteDetail] nd_options_state_by_variant keys =', Object.keys(ndStateMap || {}).length);
    } catch (_) {}

    // ✅ PATCH2: normalize properties shape to an object Shopify expects
    function normalizePropertiesShape(props) {
      if (!props) return {};

      // already plain object (not array)
      if (typeof props === 'object' && !Array.isArray(props)) return props;

      // array of {name,value} or {key,value}
      if (Array.isArray(props)) {
        var out = {};
        props.forEach(function (p) {
          if (!p) return;
          var k = p.name || p.key || p.label;
          var v = (p.value != null ? p.value : p.val);
          if (!k) return;
          out[String(k)] = (v == null ? '' : String(v));
        });
        return out;
      }

      // json string
      if (typeof props === 'string') {
        try {
          var obj = JSON.parse(props);
          if (obj && typeof obj === 'object') return obj;
        } catch (e) {}
      }

      return {};
    }

    // ✅【只加 helper：補 series + 強制 _nd_reload="1"；其餘不動】
    function normalizeBssSeriesProps(props) {
      var base = normalizePropertiesShape(props);
      var out = Object.assign({}, base || {});

      // ⭐ KEY: mark as reloaded item so cart page can detect and show our Reload Edit button
      out._nd_reload = "1";

      // optional debug/target marker
      out.ND_QUOTE_ID = String(quoteId || '');

      [
        'Double Series',
        'Single Series',
        'Hinged Series',
        'Gliding Series',
        'DGP 2 Panels series',
        'DGP 3 Panels series'
      ].forEach(function (k) {
        if (out[k] == null) out[k] = '';
      });
      return out;
    }

    clearNdLocalCache();

    var qFlat = quoteFlat || lastQuote || {};
    var norm  = normalizePayload(payload || {}, qFlat);
    var cartSnapshot = norm.cart || {};
    var meta         = norm.meta || {};

    // Prefer meta → fallback quoteFlat
    var refVal = meta.reference || qFlat.reference_numb || qFlat.reference_no || qFlat.reference || '';
    var factorVal = (meta.factor != null && meta.factor !== '') ? meta.factor : (qFlat.factor != null ? qFlat.factor : '');

    var attrs = Object.assign({}, cartSnapshot.attributes || {});
    var note  = cartSnapshot.note || '';

    var shippingFromMeta =
      meta.shipping_address ||
      meta.shipping_addres ||
      meta['Shipping Address'] ||
      '';

    var shippingFromQuote =
      qFlat.shipping_address ||
      qFlat.shipping_addres ||
      '';

    var shippingValue = shippingFromMeta || shippingFromQuote;

    // PATCH4: set multi-key aliases for stability across different cart UI scripts
    if (factorVal != null && String(factorVal).trim() !== '') setAttrAliases(attrs, 'Factor', factorVal);
    if (refVal) setAttrAliases(attrs, 'Reference Number', refVal);

    var mainContactName = meta.contact_name || qFlat.contact_name || '';
    var mainPhone       = meta.phone_number || qFlat.phone_number || '';

    if (mainContactName) {
      attrs['Contact Name'] = mainContactName;
      attrs['Shipping Contact Name'] = mainContactName;
    }

    if (mainPhone) {
      attrs['Phone Number'] = mainPhone;
      attrs['Shipping Phone'] = mainPhone;
    }

    if (meta.company_name) attrs['Company Name'] = meta.company_name;
    if (shippingValue) attrs['Shipping Address'] = shippingValue;

    if (meta.instruction) note = meta.instruction;

    function setBusy(busy) {
      if (!btn) return;
      btn.disabled = !!busy;
      btn.style.opacity = busy ? '0.6' : '1';
      btn.textContent = busy
        ? 'Loading quote into cart\u2026'
        : 'Load this quote into cart';
    }

    setBusy(true);

    // 1) clear
    fetchJsonOrThrow('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    }, 'clear')
    .then(function () {
      // 2) add items sequentially
      var chain = Promise.resolve();

      items.forEach(function (it) {
        var vid = it.variant_id || it.id;
        var qty = it.quantity || 1;
        if (!vid || !qty) return;

        chain = chain.then(function () {
          // PATCH3: inject _nd_options_state from state map (variant_id => state string)
          var props = normalizeBssSeriesProps(it.properties);

          try {
            var key = String(vid);
            var st = ndStateMap && ndStateMap[key];
            if (st && !props._nd_options_state) {
              props._nd_options_state = toStateString(st);
            }
          } catch (e) {}

          // PATCH4: also store ref/factor on line item properties (multi-key)
          props = setPropAliases(props, refVal, factorVal);

          return fetchJsonOrThrow('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: vid,
              quantity: qty,
              properties: props
            })
          }, 'add');
        });
      });

      return chain;
    })
    .then(function () {
      // 3) update attributes + note
      if (!Object.keys(attrs).length && !note) return;
      return fetchJsonOrThrow('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: attrs,
          note: note
        })
      }, 'update');
    })
    .then(function () {
      try { sessionStorage.setItem('ND_NEUMA_QUOTE_LOADED', '1'); } catch (e) {}
      // 4) redirect LAST
      window.location.href = '/cart?nd_quote_loaded=1&quote_id=' + encodeURIComponent(quoteId);
    })
    .catch(function (err) {
      console.error('[QuoteDetail] restoreCart error', err);
      setBusy(false);
      alert('Error restoring cart from this quote.');
    });
  }

  /* ---------- 新版 Quote / Shipping 卡片（外觀） ---------- */
  function renderQuoteInfoCard(q, container, beforeEl) {
    try {
      if (!q || !container) return;

      var existing = container.querySelector('.nd-quote-info-card');
      if (existing && existing.parentNode === container) container.removeChild(existing);

      var card = document.createElement('section');
      card.className = 'nd-quote-info-card';

      var title = document.createElement('h3');
      title.className = 'nd-quote-info-title';
      title.textContent = 'Quote / Shipping Info';
      card.appendChild(title);

      var grid = document.createElement('div');
      grid.className = 'nd-quote-info-grid';
      card.appendChild(grid);

      function addItem(label, value, wide) {
        if (value == null || value === '') return;
        var item = document.createElement('div');
        item.className = 'nd-quote-info-item';
        if (wide) item.className += ' nd-quote-info-item--wide';

        var labelEl = document.createElement('div');
        labelEl.className = 'nd-quote-info-label';
        labelEl.textContent = label;

        var valueEl = document.createElement('div');
        valueEl.className = 'nd-quote-info-value';
        valueEl.textContent = value;

        item.appendChild(labelEl);
        item.appendChild(valueEl);
        grid.appendChild(item);
      }

      addItem('Quote ID', q.quote_id || q.id || '');
      addItem('Created at', q.created_at || '');
      addItem('Reference #', q.reference_numb || q.reference_no || q.reference || '');
      addItem('Factor', (q.factor != null && q.factor !== '') ? String(q.factor) : '');
      addItem('Contact', q.contact_name || q.contact || '');
      addItem('Phone', q.phone_number || q.phone || '');
      addItem('Company', q.company_name || q.company || '');
      addItem('Shipping Address', q.shipping_address || q.shipping_addres || '', true);
      addItem('Special Instruction', q.special_instruction || q.instruction || '', true);

      if (beforeEl && beforeEl.parentNode === container) container.insertBefore(card, beforeEl);
      else container.appendChild(card);

      return card;
    } catch (e) {
      console.error('[QuoteDetail] renderQuoteInfoCard error', e);
    }
  }

  /* ---------- 畫畫面 ---------- */
  function renderQuotePage(q, items, restoreSource, payload) {
    root.innerHTML = '';

    var created = q.created_at || '';
    var summary = q.summary || '';

    var h1 = document.createElement('h1');
    h1.textContent = 'Quotation Detail';
    h1.style.marginBottom = '8px';
    wrapper.insertBefore(h1, root);

    var h2 = document.createElement('h2');
    h2.textContent = 'Quote Details';
    h2.style.margin = '0 0 14px';
    h2.style.fontSize = '18px';
    h2.style.fontWeight = '500';
    root.appendChild(h2);

    var infoBox = document.createElement('div');
    infoBox.style.border = '1px solid #e5e5e5';
    infoBox.style.borderRadius = '12px';
    infoBox.style.padding = '14px 16px';
    infoBox.style.marginBottom = '18px';
    infoBox.innerHTML =
      '<div style="font-size:14px;margin-bottom:6px;">' +
      '<strong>Quote ID:</strong> ' +
      escapeHtml(q.quote_id || quoteId) +
      (created
        ? ' · <strong>Created at:</strong> ' + escapeHtml(created)
        : '') +
      '</div>' +
      (summary
        ? '<div style="font-size:14px;line-height:1.5;">' +
          escapeHtml(summary) +
          '</div>'
        : '');
    root.appendChild(infoBox);

    if (items && items.length) {
      var tableWrapper = document.createElement('div');
      tableWrapper.style.overflowX = 'auto';
      tableWrapper.style.marginBottom = '12px';

      var html =
        '<table style="width:100%;border-collapse:collapse;font-size:13px;min-width:520px;">' +
        '<thead>' +
        '<tr>' +
        '<th style="text-align:left;border-bottom:1px solid #ddd;padding:6px 4px;">Product</th>' +
        '<th style="text-align:right;border-bottom:1px solid #ddd;padding:6px 4px;">Unit price</th>' +
        '<th style="text-align:right;border-bottom:1px solid #ddd;padding:6px 4px;">Qty</th>' +
        '<th style="text-align:right;border-bottom:1px solid #ddd;padding:6px 4px;">Subtotal</th>' +
        '</tr>' +
        '</thead><tbody>';

      var total = 0;
      items.forEach(function (it) {
        var title = it.product_title || it.title || '';
        if (it.variant_title) title += ' - ' + it.variant_title;
        var qty = it.quantity || 0;
        var price = (it.price || 0) / 100;
        var line = price * qty;
        total += line;

        html +=
          '<tr>' +
          '<td style="padding:6px 4px;border-bottom:1px solid #eee;max-width:360px;">' +
          escapeHtml(title) +
          '</td>' +
          '<td style="padding:6px 4px;border-bottom:1px solid #eee;text-align:right;">' +
          price.toFixed(2) +
          '</td>' +
          '<td style="padding:6px 4px;border-bottom:1px solid #eee;text-align:right;">' +
          qty +
          '</td>' +
          '<td style="padding:6px 4px;border-bottom:1px solid #eee;text-align:right;">' +
          line.toFixed(2) +
          '</td>' +
          '</tr>';
      });

      html +=
        '<tr>' +
        '<td colspan="3" style="padding:8px 4px;text-align:right;font-weight:600;">Total</td>' +
        '<td style="padding:8px 4px;text-align:right;font-weight:600;">' +
        total.toFixed(2) +
        '</td>' +
        '</tr>';

      html += '</tbody></table>';

      tableWrapper.innerHTML = html;
      root.appendChild(tableWrapper);
    } else {
      var p = document.createElement('p');
      p.style.fontSize = '13px';
      p.textContent = 'No line items were stored for this quote.';
      root.appendChild(p);
    }

    renderQuoteInfoCard(q, root, null);

    var btnRow = document.createElement('div');
    btnRow.style.display = 'flex';
    btnRow.style.flexWrap = 'wrap';
    btnRow.style.gap = '10px';
    btnRow.style.marginTop = '12px';

    function makeBtn(text, primary) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = text;
      b.style.padding = '8px 16px';
      b.style.fontSize = '13px';
      b.style.borderRadius = '9999px';
      b.style.cursor = 'pointer';
      b.style.border = '1px solid #111827';
      if (primary) {
        b.style.background = '#111827';
        b.style.color = '#ffffff';
      } else {
        b.style.background = 'transparent';
        b.style.color = '#111827';
      }
      return b;
    }

    var btnLoad = makeBtn('Load this quote into cart', true);
    btnRow.appendChild(btnLoad);
    root.appendChild(btnRow);

    btnLoad.addEventListener('click', function () {
      if (!items || !items.length) {
        alert('This quote has no cart items stored.');
        return;
      }
      restoreCart(items, payload, q, btnLoad);
    });
  }

  /* ---------- 主流程：先吃 payload_json，失敗才 fallback /cart.js ---------- */
  fetch(url)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var q = data && (data.quote || data);
      if (!q || !q.quote_id) {
        renderError('Quote not found.');
        return;
      }

      lastQuote = q;

      var rawPayload = q.payload_json || q.cart || q.payload || null;
      var payloadObj = safeParseJson(rawPayload);
      var items = payloadObj ? pickCartItems(payloadObj) : null;

      if (items && items.length) {
        console.log('[QuoteDetail] using snapshot items, count=', items.length);
        renderQuotePage(q, items, 'snapshot', payloadObj);
        return;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var liveItems = cart && Array.isArray(cart.items) ? cart.items : [];
          console.log('[QuoteDetail] fallback live cart items =', liveItems.length);
          renderQuotePage(q, liveItems, 'liveCart', null);
        })
        .catch(function (err) {
          console.error('[QuoteDetail] cart fallback error', err);
          renderQuotePage(q, [], 'none', null);
        });
    })
    .catch(function (err) {
      console.error('[QuoteDetail] fetch error', err);
      renderError('Error loading quote.');
    });
})();
